import { Injectable } from '@angular/core';
import { NavigationItem, NavigationItemChild } from './header.nav';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private navigationItems: NavigationItem[] = [];

  constructor() { }

  get getNavigationItems(): NavigationItem[] {
    return this.navigationItems;
  }

  public getNavigationItemById(id: string): NavigationItem {
    return this.navigationItems?.find((navigationItem: NavigationItem) => navigationItem.id == id) as NavigationItem;
  }

  public getNaviationItemPositionById(id: string): number {
    return this.navigationItems?.findIndex((navigationItem: NavigationItem) => navigationItem.id == id);
  }

  public getNavigationItemChildById(parentId: string, id: string): NavigationItemChild | null {
    const parent: NavigationItem = this.getNavigationItemById(parentId);

    if (!parent?.children?.length) {
      return null;
    }

    return parent.children.find((navigationItemChild: NavigationItemChild) => navigationItemChild.id == id) as NavigationItemChild;
  }

  public getNavigationItemChildPositionById(parentId: string, id: string): number {
    const parent: NavigationItem = this.getNavigationItemById(parentId);

    if (!parent?.children?.length) {
      return -1;
    }

    return parent.children.findIndex((navigationItemChild: NavigationItemChild) => navigationItemChild.id == id)
  }

  public addNavigationItem(navigationItem: NavigationItem, position?: number): void {
    const exist: boolean = this.getNavigationItemById(navigationItem.id) != null;

    if (exist) {
      return;
    }

    position == null || position == undefined ? this.navigationItems.push(navigationItem) : this.navigationItems.splice(position, 0, navigationItem);
  }

  public removeNavigationItem(id: string): void {
    const index: number = this.getNaviationItemPositionById(id);

    if (index <= -1) {
      return;
    }

    this.navigationItems.splice(index, 1);
  }

  public addNavigationItemChild(parentId: string, navigationItemChild: NavigationItemChild, position?: number): void {
    const parent: NavigationItem = this.getNavigationItemById(parentId);

    if (!parent) {
      return;
    }

    const exist: boolean = this.getNavigationItemChildById(parentId, navigationItemChild.id) != null;

    if (exist) {
      return;
    }

    position == null || position == undefined ? parent.children?.push(navigationItemChild) : this.navigationItems.splice(position, 0, navigationItemChild);
  }

  public removeNavigationItemChild(parentId: string, id: string): void {
    const parent: NavigationItem = this.getNavigationItemById(parentId);

    if (!parent) {
      return;
    }

    const index: number = this.getNavigationItemChildPositionById(parentId, id);

    if (index <= -1) {
      return;
    }

    parent.children?.splice(index, 1);
  }
}
